import React, {Component} from 'react';
import LoginForm from '../Subcomponents/LoginForm';
import withRouter from '../Functions/WithRouter';

class OrgSignIn extends Component {
    constructor(props) {
      super(props)
      this.state = {
      }
    }

    componentDidMount() {
      console.log('componentDidMount called on org')
      const { org } = this.props.params

      let reason = null
      if (this.props.location && this.props.location.search) {
        const searchParams = new URLSearchParams(this.props.location.search);
        reason = searchParams.get("reason");
      }

      this.setState({ org, reason })
    }

    render() {

      return (
        <div>
          <LoginForm roleName="Admin" orgCode={this.state.org} courseId={this.state.courseId} fromExternal={this.state.fromExternal} history={this.props.navigate} reason={this.state.reason} type="SignIn" />
        </div>
      )
    }
}

export default withRouter(OrgSignIn)
